/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Custom_AddInputs */

const en_admin_settings_custom_add = /** @type {(inputs: Admin_Settings_Custom_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add`)
};

const zh_admin_settings_custom_add = /** @type {(inputs: Admin_Settings_Custom_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`添加`)
};

/**
* | output |
* | --- |
* | "Add" |
*
* @param {Admin_Settings_Custom_AddInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_custom_add = /** @type {((inputs?: Admin_Settings_Custom_AddInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Custom_AddInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_custom_add(inputs)
	return zh_admin_settings_custom_add(inputs)
});
export { admin_settings_custom_add as "admin.settings.custom.add" }